module.exports = __webpack_public_path__ + "img/Retail18.e2ded839.png";